export default __webpack_public_path__ + "static/media/navigation-button.bc37335c.svg";